import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCompetitionAuth } from "@/modules/auth/presentation/model/useCompetitionAuth";

export function CompetitionLayout() {
  const { isLoading, isAuthenticated, isCompetitionUser } =
    useCompetitionAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && (!isAuthenticated || !isCompetitionUser)) {
      navigate({ to: "/competition/login" });
    }
  }, [isLoading, isAuthenticated, isCompetitionUser, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-svh items-center justify-center bg-background">
        <div className="size-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated || !isCompetitionUser) return null;

  return (
    <div className="flex min-h-dvh flex-col">
      <Outlet />
    </div>
  );
}
